import { Check, Coins, Gift, Sparkles } from 'lucide-react';

/**
 * Monthly subscriptions were withdrawn from sale on 2026-09-12. Recipe credit packs are the only
 * paid product, so this section must not advertise a plan a visitor cannot buy.
 *
 * Prices are deliberately not repeated here. The store sets the price the customer actually pays
 * (Bazaar and Myket each own their own product price, and the app shows the store's figure), so a
 * number hardcoded on this page would be the one place that goes stale without anyone noticing.
 */
const plans = [
    {
        icon: Gift,
        title: 'شروع رایگان',
        badge: 'برای شروع',
        text: 'بدون ثبت‌نام وارد شو و اولین دستورت را بساز؛ با ثبت‌نام شماره موبایل ۵ اعتبار هدیه می‌گیری.',
        items: [
            '۱ دستور رایگان به‌عنوان مهمان، ۵ اعتبار هدیه با ثبت‌نام',
            'ورود مواد با متن یا عکس',
            'تنظیم کامل ترجیحات',
            'دستور پخت فارسی و تاریخچه',
        ],
    },
    {
        icon: Coins,
        title: 'بسته اعتبار',
        badge: 'هر وقت لازم داشتی',
        text: 'اعتبارت تمام شد؟ یک بسته اعتبار بخر. بدون اشتراک ماهانه و بدون پرداخت تکرارشونده.',
        items: [
            'خرید یک‌باره، بدون تعهد ماهانه',
            'اعتبار تاریخ انقضا ندارد',
            'هر دستور متنی ۱ اعتبار، هر دستور تصویری ۲ اعتبار',
            'اعتبار به حساب تو بسته است، نه به دستگاه',
        ],
        featured: true,
    },
];

const Pricing = () => (
    <section id="plans" className="section plans-section">
        <div className="site-container plans-layout">
            <div className="section-heading align-start">
                <span>اول تجربه کن، بعد انتخاب کن</span>
                <h2>اول رایگان امتحان کن؛ بعد فقط به‌اندازه مصرفت اعتبار بخر</h2>
                <p>قیمت دقیق بسته‌ها را متناسب با فروشگاه نصب‌شده، داخل خود اپ می‌بینی.</p>
            </div>
            <div className="plan-grid">
                {plans.map(({ icon: Icon, title, badge, text, items, featured }) => (
                    <article className={`plan-card ${featured ? 'featured' : ''}`} key={title}>
                        <div className="plan-card-head"><Icon size={26} /><span>{badge}</span></div>
                        <h3>{title}</h3>
                        <p>{text}</p>
                        <ul>{items.map((item) => <li key={item}><Check size={16} /> {item}</li>)}</ul>
                    </article>
                ))}
            </div>
            <div className="plan-note">
                <Sparkles size={18} /> هوش‌پز تبلیغ نشان نمی‌دهد و اشتراک ماهانه نمی‌فروشد؛ فقط اعتبار هدیه ثبت‌نام و بسته‌های اعتبار یک‌باره.
            </div>
        </div>
    </section>
);

export default Pricing;
